import NAME from "./constants";

export const getLoading = store => store[NAME].isLoading;
export const getData = store => store[NAME].data;
export const getTypeList = store => store[NAME].typeList;
export const getComponentList = store => store[NAME].componentList;
export const getGridTypeList = store => store[NAME].gridTypeList;
export const getRequiredList = store => store[NAME].requiredList;
export const getFieldList = store => store[NAME].fieldList;
export const getDisabledList = store => store[NAME].disabledList;